import * as React from 'react';

import styles from './exceeded-length-error.scss';

interface ExceededLengthErrorProps {
  errors: string[];
  hint: string;
}

export const ExceededLengthError = ({
  errors, hint
}: ExceededLengthErrorProps) => {
  if ((errors?.length ?? 0) === 0) {
    return null;
  }

  return (
    <div className={styles.errorInfo}>
      <div className={styles.message}>{errors}</div>
      <div className={styles.hint}>{hint}</div>
    </div>
  );
};
